import React, { useState, useEffect } from 'react';
import DashboardLayout from './DashboardLayout';
import StaffManager from './StaffManager';
import { useDataCache } from '../contexts/DataCacheContext';
import { useAuth } from '../contexts/AuthContext';

function Staff() {
  const [loading, setLoading] = useState(true);
  const { cache, prefetchBookings } = useDataCache();
  const { user } = useAuth();
  const businessId = user?.['custom:business_id'];

  useEffect(() => {
    const loadData = async () => {
      setLoading(true);
      await prefetchBookings();
      setLoading(false);
    };
    loadData();
  }, [prefetchBookings]);

  return (
    <DashboardLayout>
      {loading ? (
        <div className="flex items-center justify-center h-64">
          <div className="w-10 h-10 border-4 border-gray-200 border-t-blue-500 rounded-full animate-spin"></div>
        </div>
      ) : (
        <div className="space-y-6">
          <div className="mb-6">
            <div className="text-4xl font-bold text-gray-900 mb-2">Staff Management</div>
            <p className="text-sm text-gray-600">Manage your team members and their availability.</p>
          </div>
          <StaffManager cachedStaff={cache.bookings?.staff} />
        </div>
      )}
    </DashboardLayout>
  );
}

export default Staff;
